/**
 * Wires `prosemirror-history` with Cmd/Ctrl+Z / Shift+Cmd/Ctrl+Z plus the
 * Y-redo shortcut used on Windows.
 */
import { keymap } from 'prosemirror-keymap';
import { history, undo, redo } from 'prosemirror-history';

export function buildHistory() {
  return [
    history(),
    keymap({
      'Mod-z': undo,
      'Mod-Z': undo,
      'Mod-y': redo,
      'Mod-Y': redo,
      'Shift-Mod-z': redo,
      'Shift-Mod-Z': redo,
    }),
  ];
}
